import { useState, useEffect, useCallback } from 'react';

interface UseTagManagementOptions {
  maxTags?: number;
  initialTags?: string;
}

export const useTagManagement = (options: UseTagManagementOptions = {}) => {
  const { maxTags = 5, initialTags = '' } = options;

  const [tagList, setTagList] = useState<string[]>([]);
  const [currentTag, setCurrentTag] = useState('');

  useEffect(() => {
    if (initialTags && typeof initialTags === 'string') {
      setTagList(initialTags.split(',').filter(tag => tag.trim()));
    }
  }, [initialTags]);

  const handleTagKeyPress = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        if (currentTag.trim() && !tagList.includes(currentTag.trim()) && tagList.length < maxTags) {
          setTagList(prev => [...prev, currentTag.trim()]);
          setCurrentTag('');
        }
      }
    },
    [currentTag, tagList, maxTags]
  );

  const removeTag = useCallback((tagToRemove: string) => {
    setTagList(prev => prev.filter(tag => tag !== tagToRemove));
  }, []);

  const resetTags = useCallback(() => {
    setTagList([]);
    setCurrentTag('');
  }, []);

  const getTagsString = useCallback(() => tagList.join(','), [tagList]);

  return {
    tagList,
    currentTag,
    setCurrentTag,
    handleTagKeyPress,
    removeTag,
    resetTags,
    getTagsString,
    isMaxTagsReached: tagList.length >= maxTags,
  };
};
